/**
 * Controller de classificação de produtos
 */

import { classificacaoService } from '@services';
import { Classificacao } from '@types';

export class ClassificacaoController {
  /**
   * Obtém todas as classificações
   */
  async obterClassificacoes(): Promise<Classificacao[]> {
    try {
      const classificacoes = await classificacaoService.obterClassificacoes();
      return classificacoes;
    } catch (error: any) {
      console.error('Erro ao obter classificações:', error);
      throw error;
    }
  }

  /**
   * Obtém classificação por código
   */
  async obterPorCodigo(codigo: string): Promise<Classificacao | null> {
    try {
      const classificacao = await classificacaoService.obterPorCodigo(codigo);
      return classificacao;
    } catch (error: any) {
      console.error('Erro ao obter classificação:', error);
      throw error;
    }
  }

  /**
   * Busca classificações por nome
   */
  async buscar(termo: string): Promise<Classificacao[]> {
    try {
      const classificacoes = await classificacaoService.buscar(termo);
      return classificacoes;
    } catch (error: any) {
      console.error('Erro ao buscar classificações:', error);
      throw error;
    }
  }

  /**
   * Ordena classificações por nome
   */
  ordenarPorNome(
    classificacoes: Classificacao[],
    ordem: 'asc' | 'desc' = 'asc'
  ): Classificacao[] {
    return [...classificacoes].sort((a, b) => {
      return ordem === 'asc'
        ? a.nome.localeCompare(b.nome)
        : b.nome.localeCompare(a.nome);
    });
  }

  /**
   * Ordena classificações por total de produtos
   */
  ordenarPorTotal(
    classificacoes: Classificacao[],
    ordem: 'asc' | 'desc' = 'desc'
  ): Classificacao[] {
    return [...classificacoes].sort((a, b) => {
      const totalA = parseInt(a.total);
      const totalB = parseInt(b.total);
      return ordem === 'asc' ? totalA - totalB : totalB - totalA;
    });
  }
}

export const classificacaoController = new ClassificacaoController();